import React from 'react'
import Popup from '../components/Popup'
import Button from '../components/Button'
import { UserType } from '../types/userTypes'

const ConfirmUserTypePopup: React.FC<{
  selectedUserType: UserType
  onConfirm: () => void
  onClose: () => void
}> = ({
  selectedUserType,
  onConfirm,
  onClose
}) => {
  return (
    <Popup onClose={onClose}>
      {selectedUserType === UserType.Consumer && (
        <div className="title center">
          <p>You are leaving the Trade tool.</p>
          <p>You are moving to a “Homeowner”, simplified view of this online tool.</p>
          <p>All items in your List will be kept. You can change back to the Trade site any time.</p>
          <p>Do you want to proceed?</p>
        </div>
      )}
      {selectedUserType === UserType.Electrician && (
        <div className="title center">
          <p>You are moving to a “Trade specific” environment of this online tool.</p>
          <p>All items in your List will be kept. You can change back to the Homeowner site any time.</p>
          <p>Do you want to proceed?</p>
        </div>
      )}
      <div className="buttonRow">
        <Button
          buttonStyle="redStroke"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          buttonStyle="green"
          onClick={onConfirm}
        >
          Continue
        </Button>
      </div>
    </Popup>
  )
}

export default ConfirmUserTypePopup